import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface AccountBlockStatus {
  blocked: boolean;
  just_unblocked?: boolean;
  block_type?: "chargeback" | "open_invoices";
  blocked_at?: string;
  invoices?: { id: string; number: string | null; period_start: number | null; period_end: number | null; amount_cents: number; processing?: boolean }[];
  total_cents?: number;
  covered_count?: number;
  paid_count?: number;
  processing?: boolean;
  pay_link?: string | null;
}

/** Blokkadestatus. Snelle check via eigen rij, details (live uit Stripe) via de server. */
export function useAccountBlock() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["account-block", user?.id],
    enabled: !!user?.id,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    // Zolang geblokkeerd: elke 30 s opnieuw, zodat de popup na betalen vanzelf verdwijnt.
    refetchInterval: (q) => ((q.state.data as AccountBlockStatus | undefined)?.blocked ? 30_000 : false),
    queryFn: async (): Promise<AccountBlockStatus> => {
      const { data: row } = await supabase
        .from("account_blocks" as any)
        .select("id")
        .eq("user_id", user!.id)
        .is("unblocked_at", null)
        .limit(1)
        .maybeSingle();
      if (!row) return { blocked: false };
      const { data, error } = await supabase.functions.invoke("account-block-status");
      if (error || !data) return { blocked: true, invoices: [], total_cents: 0, pay_link: null };
      return data as AccountBlockStatus;
    },
  });
}
